import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextareaComponent } from './textarea.component';
import { TooltipModule } from '../../tooltip/tooltip.module';

@NgModule({
  declarations: [TextareaComponent],
  imports: [CommonModule, TooltipModule],
  exports: [TextareaComponent],
})
export class TextareaModule {}
